export default "__VITE_ASSET__720f9787__"